/**
 * Converte um objeto Contact (do backend, formato ContactListSerializer)
 * pra Conversation (formato esperado pelo ServiceCenter — sidebar, chat, etc.).
 *
 * Usado quando temos o Contact mas a Conversation correspondente não está
 * carregada na lista local (resultado de busca, item da fila, etc.).
 */
export const contactToConversation = (c) => {
  if (!c) return null;
  // Detecta o canal: se vier do backend Instagram, instagram_id estará
  // populado e phone/whatsapp_id vazios. Senão, é WhatsApp.
  const isInstagram = !!c.instagram_id && !c.whatsapp_id;
  const channel = isInstagram ? 'instagram' : 'whatsapp';
  const channelUserId = isInstagram ? c.instagram_id : (c.whatsapp_id || c.phone);

  return {
    id: channelUserId || `contact-${c.id}`,
    contact_id: c.id,
    channel,
    channel_user_id: channelUserId,
    phone: c.phone || channelUserId,
    phone_raw: c.phone || channelUserId,
    name: c.name || channelUserId || c.phone,
    avatar:
      c.picture_url ||
      `https://ui-avatars.com/api/?name=${encodeURIComponent(
        c.name || c.phone || channelUserId || ""
      )}&background=random`,
    lastMessage: "",
    lastMessageTime: "",
    lastMessageTimestamp: c.last_message_at
      ? Math.floor(new Date(c.last_message_at).getTime() / 1000)
      : 0,
    fromMe: false,
    whatsapp_id: c.whatsapp_id,
    whatsapp_lid: c.whatsapp_lid,
    instagram_id: c.instagram_id,
    service_status: c.service_status,
    service_status_display: c.service_status_display,
    current_attendant_id: c.current_attendant,
    current_attendant_name: c.current_attendant_name,
    current_department_id: c.current_department,
    current_department_name: c.current_department_name,
    tags: c.tags,
    bot_status: c.bot_status ?? 1,
    source: c.source || channel,
    temperature: c.temperature || null,
    priority: c.priority || null,
    deal_value: c.deal_value || null,
    messages: [],
  };
};

/**
 * Constrói uma Conversation mínima a partir só de um telefone (Camada 2 do
 * híbrido — fallback "Abrir chat com {phone}" quando o Contact não existe
 * no banco local mas o usuário quer tentar abrir mesmo assim).
 *
 * O backend ChatMessagesView vai chamar a WAHA `/chats/{phone}@c.us/messages`
 * direto. Se houver mensagens, o ContactSyncService cria o Contact pelo
 * fluxo normal de webhook/sync.
 */
export const phoneToConversation = (phone) => {
  const cleaned = String(phone || "").replace(/\D/g, "");
  if (!cleaned) return null;
  return {
    id: `phone-${cleaned}`,
    contact_id: null,
    phone: cleaned,
    phone_raw: cleaned,
    name: cleaned,
    avatar: `https://ui-avatars.com/api/?name=${cleaned}&background=random`,
    lastMessage: "",
    lastMessageTime: "",
    lastMessageTimestamp: 0,
    fromMe: false,
    whatsapp_id: `${cleaned}@c.us`,
    whatsapp_lid: null,
    service_status: "new",
    service_status_display: "Novo",
    bot_status: 1,
    source: "whatsapp",
    messages: [],
  };
};
